import { Link } from "react-router-dom";
import { ExternalLink, ArrowRight, GraduationCap, Users } from "lucide-react";

const SER_MEMBERSHIP_URL = "https://www.ser.org/page/Membership";
const STUDENT_COVER = "/api/media/ser-africa/uploads/student-group-0bea8a69.jpg";

export default function MembershipPage() {
  return (
    <div data-testid="membership-page">
      <section
        className="ser-section text-center"
        style={{
          background: "linear-gradient(160deg, var(--ser-primary-dark) 0%, var(--ser-primary) 70%)",
          color: "white",
        }}
      >
        <div className="ser-container max-w-4xl">
          <p className="eyebrow mb-4" style={{ color: "var(--ser-clay)" }}>Membership</p>
          <h1 className="font-serif-display text-5xl md:text-7xl mb-5">Join SER Africa</h1>
          <p className="text-lg" style={{ color: "rgba(255,255,255,0.8)" }}>
            Be part of Africa&rsquo;s leading network for ecological restoration. Gain access to events, resources, and a community of like-minded practitioners.
          </p>
        </div>
      </section>

      <section className="ser-section">
        <div className="ser-container max-w-2xl">
          <div className="ser-card p-8 md:p-10 text-center" data-testid="membership-card">
            <p className="eyebrow mb-3">Become a Member</p>
            <h2
              className="font-serif-display text-3xl md:text-4xl mb-4"
              style={{ color: "var(--ser-primary-dark)" }}
            >
              Membership is managed by SER globally.
            </h2>
            <p
              className="text-sm md:text-base leading-relaxed mb-8"
              style={{ color: "var(--ser-text-muted)" }}
            >
              Membership tiers, benefits, and applications are handled through the
              Society for Ecological Restoration&rsquo;s global membership portal. Follow
              the link below to view current membership options and sign up.
            </p>
            <a
              href={SER_MEMBERSHIP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-ser-primary inline-flex items-center gap-2"
              data-testid="ser-membership-link"
            >
              Visit SER Membership <ExternalLink className="w-4 h-4" />
            </a>
            <p
              className="mt-4 text-xs break-all"
              style={{ color: "var(--ser-text-muted)" }}
            >
              {SER_MEMBERSHIP_URL}
            </p>
          </div>
        </div>
      </section>

      {/* Student Chapters in Africa */}
      <section
        className="ser-section"
        style={{ backgroundColor: "var(--ser-section-alt)" }}
        data-testid="membership-student-chapters"
      >
        <div className="ser-container max-w-6xl">
          <div className="ser-card overflow-hidden grid md:grid-cols-2">
            <div className="aspect-video md:aspect-auto overflow-hidden bg-black">
              <img
                src={STUDENT_COVER}
                alt="SER Africa Student Chapters"
                loading="lazy"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="p-8 md:p-10 flex flex-col">
              <p
                className="text-[11px] font-bold uppercase tracking-wider mb-3 flex items-center gap-2"
                style={{ color: "var(--ser-primary)" }}
              >
                <GraduationCap className="w-4 h-4" /> Student Chapters in Africa
              </p>
              <h2
                className="font-serif-display text-2xl md:text-3xl mb-4"
                style={{ color: "var(--ser-primary-dark)" }}
              >
                Building Student Networks
              </h2>
              <p className="text-sm leading-relaxed mb-5" style={{ color: "var(--ser-text-muted)" }}>
                As part of our ongoing efforts to expand ecological restoration networks in Africa,
                SER Africa (SERAf) is setting up two new student chapters in Kenya, as outlined in
                our current partnership fund proposal. To make this a success, we're reaching out
                to members who are affiliated with universities in Kenya.
              </p>
              <Link
                to="/student-chapters"
                className="btn-ser-primary inline-flex items-center gap-2 self-start mt-auto"
                data-testid="student-chapters-explore-btn"
              >
                Explore &amp; Apply <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Each One Reach One Campaign — placeholder */}
      <section className="ser-section" data-testid="membership-each-one">
        <div className="ser-container max-w-3xl text-center">
          <p
            className="text-[11px] font-bold uppercase tracking-wider mb-3 flex items-center justify-center gap-2"
            style={{ color: "var(--ser-clay)" }}
          >
            <Users className="w-4 h-4" /> Coming soon
          </p>
          <h2
            className="font-serif-display text-2xl md:text-3xl mb-4"
            style={{ color: "var(--ser-primary-dark)" }}
          >
            Each One Reach One Campaign
          </h2>
          <p className="text-sm leading-relaxed" style={{ color: "var(--ser-text-muted)" }}>
            Full details of the campaign will be shared here shortly. Watch this space, or reach us at{" "}
            <a href="mailto:africa@ser.org" style={{ color: "var(--ser-primary)" }}>
              africa@ser.org
            </a>{" "}
            to learn more.
          </p>
        </div>
      </section>
    </div>
  );
}
